import * as React from 'react';
import FormView from 'components/FormView';
import { withRouter } from 'react-router';
import { IEventsFields } from '../interfaces';

class Events extends React.PureComponent<IEventsFields> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/rfc-enquiry/notepad':
          onInitialLoad('Notepad');
          break;
        default:
          onInitialLoad('RFCDetails');
      }
    }
  }
  getInitialValues = () => {
    const {
      selectedTab, selectedRFC, location
    } = this.props;
    const params = (new URLSearchParams(location.search));
    const RFCNumber = parseInt(params.get('RFCNumber'));
    switch (selectedTab) {
      case 'Notepad':
        return {
          params: {
              RFCNumber: (selectedRFC && selectedRFC.RFCNumber) || RFCNumber,
            }
        };
      default:
        return null;
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading, summaryTableRenderer } = this.props;
    const initialValues = this.getInitialValues();

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={initialValues}
          operationMode={operationMode}
          enableReinitialize={true}
          summaryTableRenderer={summaryTableRenderer}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(Events);
